module.exports = __webpack_public_path__ + "img/left-arrow.8b342bf9.svg";